export default function InitialiseJobsCard({ useOnboardingStore }) {
  const { isGenerateJobs } = useOnboardingStore();

  const setIsGenerateJobs = useOnboardingStore((state) => state.setIsGenerateJobs);

  return (
    <div className="initialise-option">
      <div className="icon">
        <i className="fe fe-briefcase" />
      </div>
      <div className="details">
        <h3>Jobs</h3>
        <p>Generate random jobs. Used during development and for testing purposes only</p>
      </div>
      <div className="options">
        <div className="form-check option">
          <input
            className="form-check-input"
            type="checkbox"
            id="initialise-option-jobs"
            name="initialise-option-jobs"
            checked={isGenerateJobs}
            onChange={(e) => setIsGenerateJobs(e.target.checked)}
          />
          <label className="form-check-label option-details" htmlFor="initialise-option-jobs" style={{ cursor: 'pointer' }}>
            <h4 className="title">3 Random Jobs</h4>
            <p className="description">Generate THREE(3) random jobs. No location and job categories will be set</p>
          </label>
        </div>
      </div>
    </div>
  );
}
